// extracted by mini-css-extract-plugin
export var black = "_4d-6";
export var brand = "_4d-1";
export var ddefault = "_4d-0";
export var error = "_4d-3";
export var gray = "_4d-2";
export var highContrast = "_4d-8";
export var outline = "_4d-7";
export var success = "_4d-5";
export var warning = "_4d-4";